import { ServiceURL } from '~/__modules__/env';

export const MenuItemId = {
  PERSONAL_INFO: 'PERSONAL_INFO',
  SECURITY: 'SECURITY',
  NOTIFY: 'NOTIFY',
  BOARD: 'BOARD',
  MESSAGE: 'MESSAGE',
  MAIL: 'MAIL',
  CALENDAR: 'CALENDAR',
  CONTACT: 'CONTACT',
  DRIVE: 'DRIVE',
  TASK: 'TASK',
  FORM: 'FORM',
};

export const MenuItemURL = {
  ...(process.env.PHASE === undefined
    ? { SAMPLE: `${process.env.SAMPLE_URL}/settings` }
    : {}),
  [MenuItemId.PERSONAL_INFO]: `${ServiceURL.CONTACT}/personal-info-settings`,
  [MenuItemId.SECURITY]: `${ServiceURL.COMMON}/security-settings`,
  [MenuItemId.NOTIFY]: `${ServiceURL.NOTIFY}/settings`,
  [MenuItemId.BOARD]: `${ServiceURL.BOARD}/settings`,
  [MenuItemId.MESSAGE]: `${ServiceURL.TALK}/settings`,
  [MenuItemId.MAIL]: `${ServiceURL.MAIL}/settings`,
  [MenuItemId.CALENDAR]: `${ServiceURL.CALENDAR}/settings`,
  [MenuItemId.CONTACT]: `${ServiceURL.CONTACT}/settings`,
  [MenuItemId.DRIVE]: `${ServiceURL.DRIVE}/settings`,
  [MenuItemId.TASK]: `${ServiceURL.TASK}/settings`,
  [MenuItemId.FORM]: `${ServiceURL.FORM}/settings`,
};
